var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-tabs',[_c('b-tab',{attrs:{"active":""},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"d-none d-sm-inline"},[_vm._v("Ingresos y gastos")])]},proxy:true}])},[_c('ListExpenses')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }